import {
  customElement,
  DeesElement,
  property,
  html,
  cssManager,
  css,
  type TemplateResult,
} from '@design.estate/dees-element';

const kindColors: Record<string, string> = {
  feat: '#22c55e',
  perf: '#f59e0b',
  fix: '#ef4444',
  docs: '#3b82f6',
  test: '#14b8a6',
  ref: '#8b5cf6',
  build: '#64748b',
  ci: '#64748b',
  chore: '#64748b',
  rel: '#8b5cf6',
  break: '#dc2626',
  code: '#64748b',
};

const labelByKind: Record<string, string> = {
  refactor: 'ref',
  release: 'rel',
  commit: 'code',
  breaking: 'break',
};

@customElement('dotglobal-change-badge')
export class DotglobalChangeBadge extends DeesElement {
  @property({ type: String })
  public accessor kind = 'code';

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        display: inline-flex;
        flex: 0 0 auto;
        width: 46px;
        vertical-align: middle;
      }

      .pill {
        width: 46px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 1px 7px;
        border: 1px solid color-mix(in srgb, var(--badge-color) 45%, transparent);
        border-radius: 999px;
        color: var(--badge-color);
        background: color-mix(in srgb, var(--badge-color) 12%, transparent);
        font-size: 10.5px;
        font-weight: 600;
        letter-spacing: 0;
        text-align: center;
        white-space: nowrap;
      }
    `,
  ];

  public render(): TemplateResult {
    const label = this.getLabel();
    const color = kindColors[label] ?? kindColors.code;
    return html`<span class="pill" style=${`--badge-color:${color}`} title=${this.kind}>${label}</span>`;
  }

  private getLabel(): string {
    const normalized = this.kind.trim().toLowerCase() || 'code';
    return labelByKind[normalized] ?? normalized;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'dotglobal-change-badge': DotglobalChangeBadge;
  }
}
